import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d0b85474&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0b85474')) {
      api.createRecord('d0b85474', component.options)
    } else {
      api.reload('d0b85474', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d0b85474&", function () {
      api.rerender('d0b85474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203o1cdn0pv03/JS/offershelp.vue"
export default component.exports